import { Injectable } from '@angular/core';
import { CanLoad } from '@angular/router';
import { AppPermissionsService } from '@check-list/shared/services/permissions/permissions.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuardService implements CanLoad {
  private permissionsLoaded = false;

  constructor(
    private authService: AuthenticationService,
    private appPermissionsService: AppPermissionsService
  ) {}

  canLoad(): boolean | Observable<boolean> | Promise<boolean> {
    if (this.authService.isAuthenticated()) {
      // Load granular permissions from the API (once per session)
      if (!this.permissionsLoaded) {
        this.permissionsLoaded = true;
        return this.appPermissionsService
          .loadPermissions()
          .pipe(map(() => true));
      }

      return true;
    } else {
      const url = location.pathname + location.search;
      this.authService.relogin(url);
      return false;
    }
  }
}
